import React from "react";
import "./Fee_Enrollment.css";

const Fee_Enrollment = () => {
  const Fee = [
    {
      title: "Flexible & Affordable Learning",
      desc:
        "High-quality career training at a price designed to be accessible and value-driven.",
    },
    {
      title: "EMI Options Available",
      desc:
        "Flexible monthly payment plans to make learning easy and stress-free.",
    },
    {
      title: "Limited Seats per Batch",
      desc:
        "Small batch sizes ensure personalized attention and better learning support.",
    },
  ];
  return (
    <section className="Fee_Enrollment">
      <div className="container">
        <h5 className="Fee_Enrollment_title">Fees & Enrollment</h5>

        <div className="fee_enrollment_div">
          <div className="row g-4 justify-content-center">
            {Fee.map((item, index) => (
              <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="fee_box">
                  <h5 className="title">{item.title}</h5>
                  <p className="desc">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Fee_Enrollment;
